import { Currency } from '@/core/currency/interfaces';

const TOP: Currency = {
    name: 'Tongan Paʻanga',
    demonym: 'Tongan',
    majorSingle: "Pa'anga",
    majorPlural: "Pa'anga",
    codeNumeric: '776',
    symbol: 'T$',
    symbolNative: 'PT',
    minorSingle: 'Seniti',
    minorPlural: 'Seniti',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'TOP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default TOP;
